import { IconWrapper } from '../runtime';
export default IconWrapper('fp-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3.75C0 1.67893 1.67893 0 3.75 0H20.25C22.3211 0 24 1.67893 24 3.75V20.25C24 22.3211 22.3211 24 20.25 24H3.75C1.67893 24 0 22.3211 0 20.25V3.75Z",
      "fill": 'url(#' + props.id + '49505557' + ')'
    }
  }), h("path", {
    "attrs": {
      "d": "M5.25 6.75C5.25 6.33579 5.58579 6 6 6H18C18.4142 6 18.75 6.33579 18.75 6.75V7.5C18.75 7.91421 18.4142 8.25 18 8.25H6C5.58579 8.25 5.25 7.91421 5.25 7.5V6.75Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M5.25 11.625C5.25 11.2108 5.58579 10.875 6 10.875H18C18.4142 10.875 18.75 11.2108 18.75 11.625V12.375C18.75 12.7892 18.4142 13.125 18 13.125H6C5.58579 13.125 5.25 12.7892 5.25 12.375V11.625Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M5.25 16.5C5.25 16.0858 5.58579 15.75 6 15.75H13.5C13.9142 15.75 14.25 16.0858 14.25 16.5V17.25C14.25 17.6642 13.9142 18 13.5 18H6C5.58579 18 5.25 17.6642 5.25 17.25V16.5Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '49505557',
      "x1": "0",
      "y1": "0",
      "x2": "24",
      "y2": "24",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#6EB1FF"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#7A4BFA"
    }
  })])])]);
});